export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "Axis Bank Car Loan EMI Calculator: Drive Your Dream with Smart Planning",
    subHeading:
      "The Axis Bank Car Loan EMI Calculator helps you estimate your monthly payments, plan your finances, and choose the best repayment strategy before purchasing your dream car. Whether you're buying a new car, a used car, or opting for an electric vehicle, this tool ensures a stress-free borrowing experience with instant EMI breakdowns.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
